import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/shared/shadcn/ui/dialog';
import FacilitySelection from '@/features/Auth/components/facility-selection/FacilitySelection';
import { FacilityOption } from '@/features/Auth/types';

interface FacilitySwitcherDialogProps {
  isOpen: boolean;
  onClose: () => void;
  facilities: FacilityOption[];
  currentPracticeId: number;
  onSwitch: (index: number) => void;
}

const FacilitySwitcherDialog: React.FC<FacilitySwitcherDialogProps> = ({
  isOpen,
  onClose,
  facilities,
  currentPracticeId,
  onSwitch,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-transparent border-0 shadow-none p-0 max-w-fit [&>button]:hidden">
        <DialogTitle className="sr-only">Switch Facility</DialogTitle>
        <FacilitySelection
          facilities={facilities}
          onSelect={onSwitch}
          currentPracticeId={currentPracticeId}
          description="Please choose the facility you want to switch"
        />
      </DialogContent>
    </Dialog>
  );
};

export default FacilitySwitcherDialog;

